import * as React from 'react';
import { OAuthCredential } from 'firebase/auth';
import { FirebaseApp } from 'firebase/app';
import {
  FirebaseAuthService,
  FirebaseAuthServiceProvider,
} from 'services/firebase-auth-service';

import { SocialButton } from './styles';

export type FirebaseLoginButtonProps =
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    provider: FirebaseAuthServiceProvider;
    firebaseApp?: FirebaseApp;
    onSuccess: (credential: OAuthCredential) => void;
    onError?: (error: Error) => void;
  };

const FirebaseSignInButton = React.forwardRef<
  HTMLButtonElement,
  FirebaseLoginButtonProps
>((props, ref) => {
  const { provider, onSuccess, onError, firebaseApp, ...rest } = props;

  const handleClick = React.useCallback(async () => {
    try {
      const credential = await FirebaseAuthService.signInWithPopup(
        provider,
        firebaseApp
      );
      onSuccess(credential);
    } catch (e) {
      if (e instanceof Error) {
        onError?.(e);
      }
    }
  }, [firebaseApp, onError, onSuccess, provider]);

  return <SocialButton ref={ref} {...rest} onClick={handleClick} />;
});
FirebaseSignInButton.displayName = 'FirebaseSignInButton';

export { FirebaseSignInButton };
